import { createFileRoute } from '@tanstack/react-router';
import CaseLabelsView from '../admin/orders/CaseLabelsView';
export const Route = createFileRoute('/admin/order/case-labels')({ component: CaseLabelsView });
